import {
  currencyRateConversion,
  formatAmount,
} from "../../../utils/hooks/dataHandler";
import MainComputationCalculator from "../../../builders/calculator/mainComputation";
import { boldAutoColumn } from "../../../utils/pdf/page";
import {
  createExchangeRateResolver,
  getCellContent,
  parsePdfAmount,
} from "./shared";

export const createMainComputationSgdColumn = ({
  currencyRate,
  getRowExchangeRate,
  rowExchangeRates,
  sgdAmountOverrides,
  shouldSkipRow,
  unutilisedCapitalAllowances = [],
  unutilisedDonations = [],
  unutilisedLosses = [],
}) => {
  const exchangeRate = currencyRate ?? 1;
  const getExchangeRate = createExchangeRateResolver(exchangeRate);

  const getSgdAmountCell = (row) => {
    const amount = parsePdfAmount(row[2]) ?? parsePdfAmount(row[1]);
    if (amount == null) return "";

    if (sgdAmountOverrides?.has(row)) {
      return formatAmount(Math.round(sgdAmountOverrides.get(row)));
    }

    if (getCellContent(row[0]) === "Chargeable Income Before Exempt Amount") {
      return formatAmount(
        Math.round(
          MainComputationCalculator.convertChargeableIncomeToSgd(
            amount,
            exchangeRate,
            [
              ...unutilisedCapitalAllowances,
              ...unutilisedLosses,
              ...unutilisedDonations,
            ]
          )
        )
      );
    }

    const rate = getExchangeRate(
      rowExchangeRates?.get(row) ?? getRowExchangeRate?.(row)
    );
    return formatAmount(
      Math.round(currencyRateConversion(amount, rate, "SGD"))
    );
  };

  const addSgdHeader = (headers) => {
    headers.splice(3, 0, boldAutoColumn("SGD"));
  };

  const addSgdColumnThroughRow = (body, endRowIndex) => {
    if (endRowIndex < 0) return;

    for (let index = 0; index <= endRowIndex; index++) {
      const row = body[index];
      if (!row || row.length === 0 || shouldSkipRow?.(row)) continue;

      while (row.length < 4) row.push("");
      row.splice(3, 0, {
        content: getSgdAmountCell(row),
      });
    }
  };

  return {
    addSgdColumnThroughRow,
    addSgdHeader,
    getSgdAmountCell,
  };
};
